"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLDPayload = useLDPayload;
var _reactRedux = require("react-redux");
var _getURLPathParams = require("@studio/logger/utils/getURLPathParams");
var _react = require("react");
var _nanoid = require("nanoid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Custom hook to construct the LaunchDarkly payload from Redux state.
 *
 * @returns {Object|undefined} The ldPayload object for LaunchDarkly initialization
 */
function useLDPayload() {
  var user = (0, _reactRedux.useSelector)(function (state) {
    return state.user;
  }, _reactRedux.shallowEqual);
  var isStandAloneReadinessCheckPage = (0, _react.useMemo)(function () {
    var _globalThis$location;
    return ((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.pathname) === '/studio-presenter/check';
  }, []);
  var fakeUserForReadinessCheck = (0, _react.useMemo)(function () {
    return {
      firstName: 'Standalone',
      lastName: 'User',
      email: 'stand+alone+user@cvent.com',
      _id: "standalone-readiness-check-user-".concat((0, _nanoid.nanoid)())
    };
  }, []);
  if (isStandAloneReadinessCheckPage) {
    user = fakeUserForReadinessCheck;
  }
  var _ref = (0, _getURLPathParams.getURLPathParams)() || {},
    teamId = _ref.teamId,
    eventId = _ref.eventId,
    broadcastId = _ref.broadcastId;
  var team = (0, _reactRedux.useSelector)(function (state) {
    var _state$team, _state$team2;
    return {
      externalId: (_state$team = state.team) === null || _state$team === void 0 ? void 0 : _state$team.externalId,
      createdOn: (_state$team2 = state.team) === null || _state$team2 === void 0 ? void 0 : _state$team2.createdOn
    };
  }, _reactRedux.shallowEqual);
  var event = (0, _reactRedux.useSelector)(function (state) {
    var _state$event;
    return {
      createdOn: (_state$event = state.event) === null || _state$event === void 0 ? void 0 : _state$event.createdOn
    };
  }, _reactRedux.shallowEqual);
  var broadcast = (0, _reactRedux.useSelector)(function (state) {
    var _state$broadcast$crea, _state$broadcast, _state$settings;
    return {
      createdOn: (_state$broadcast$crea = (_state$broadcast = state.broadcast) === null || _state$broadcast === void 0 ? void 0 : _state$broadcast.createdOn) !== null && _state$broadcast$crea !== void 0 ? _state$broadcast$crea : (_state$settings = state.settings) === null || _state$settings === void 0 ? void 0 : _state$settings.createdOn
    };
  }, _reactRedux.shallowEqual);
  if (user && broadcast && team && event) {
    return {
      user: user,
      team: _objectSpread(_objectSpread({
        key: teamId
      }, team.createdOn && {
        createdOn: team.createdOn
      }), team.externalId && {
        accountMappingId: team.externalId
      }),
      event: _objectSpread({
        key: eventId
      }, event.createdOn && {
        createdOn: event.createdOn
      }),
      broadcast: _objectSpread({
        key: broadcastId
      }, broadcast.createdOn && {
        createdOn: broadcast.createdOn
      })
    };
  }
}